import { render } from "./DeleteUserModal.vue?vue&type=template&id=0e105fec"
import script from "./DeleteUserModal.vue?vue&type=script&lang=js"
export * from "./DeleteUserModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__